module.exports = __webpack_public_path__ + "img/header.5a20c3f8.jpg";